import { VStack, HStack, Text } from '@chakra-ui/react';
import { LOWERCASE_LETTER, SPECIAL_CHARACTER, UPPERCASE_LETTER } from '@utils/regex';
import { MdCheckCircle, MdCircle } from 'react-icons/md';

type Props = {
  password: string;
};

const PasswordValidator = ({ password }: Props) => {
  const rules = [
    {
      label: '8 dígitos',
      isValid: password.length >= 8,
    },
    {
      label: 'Pelo menos uma maiúscula',
      isValid: UPPERCASE_LETTER.test(password),
    },
    {
      label: 'Pelo menos uma minúscula',
      isValid: LOWERCASE_LETTER.test(password),
    },
    {
      label: 'Um caractere especial',
      isValid: SPECIAL_CHARACTER.test(password),
    },
  ];

  return (
    <VStack align="start" gap={1}>
      {rules.map((rule, index) => (
        <HStack key={index} gap={2} color={rule.isValid ? 'green.500' : 'fg.muted'}>
          {rule.isValid ? (
            <MdCheckCircle size={14} />
          ) : (
            <MdCircle size={14} />
          )}
          <Text fontSize="sm">
            {rule.label}
          </Text>
        </HStack>
      ))}
    </VStack>
  );
};

export default PasswordValidator;